import React from 'react';
import '../../css/Dashboard.css';

type Props = {
  month: '' | 'prev' | 'last3' | 'ytd';
  assignee: string;
  onChange: (next: Partial<Props>) => void;
  assigneeOptions?: Array<{ value: string; label: string }>;
};

const FiltersBar: React.FC<Props> = ({ month, assignee, onChange, assigneeOptions }) => {
  const handle = (key: keyof Props) => (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange({ [key]: e.target.value } as any);
  };

  return (
    <div className="filters-bar">
      <label className="filter">
        <span>Month</span>
        <select value={month} onChange={handle('month')}>
          <option value="">This Month</option>
          <option value="prev">Previous Month</option>
          <option value="last3">Last 3 Months</option>
          <option value="ytd">Year to Date</option>
        </select>
      </label>
      <label className="filter">
        <span>Assignee</span>
        <select value={assignee} onChange={handle('assignee')}>
          <option value="">All</option>
          {(assigneeOptions && assigneeOptions.length > 0
            ? assigneeOptions
            : []
            ).map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
        </select>
      </label>
    </div>
  );
};

export default FiltersBar;
